import React, { Component } from 'react'
import PropTypes from 'prop-types'

import DebugConsole from './debug-console-view'

class DebugConsoleContainer extends Component {
  state = {
    messages: [],
    isExpanded: false,
  }

  pushMessage = e => {
    this.setState({ messages: this.state.messages.slice(0).concat([e.detail]) })
  }

  clearMessages = e => {
    e.stopPropagation()
    this.setState({ messages: [] })
  }

  toggleExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  componentDidMount() {
    window.addEventListener('logMessage', this.pushMessage)
    this.setState({ messages: window.console._allMessages.slice(0) })
  }

  componentwillUnmount() {
    window.removeEventListener('logMessage', this.pushMessage)
  }

  render() {
    // do not use console.log here. it would start an infinite loop

    if (this.props.isEnabled !== true) return null

    return (
      <DebugConsole
        messages={this.state.messages}
        isExpanded={this.state.isExpanded}
        toggleMessages={this.toggleExpand}
        clearMessages={this.clearMessages}
      />
    )
  }

}

DebugConsoleContainer.propTypes = {
  isEnabled: PropTypes.bool,
}

export default DebugConsoleContainer
